import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./ContactUs.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const ContactUs = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const form = useRef(null);

  const submitHandler = (e) => {
    e.preventDefault();
    if (!name || !email || !message) {
      return toast.error("Please complete the form above");
    }

    setLoading(true);

    emailjs
      .sendForm("service_comq6fl", "template_mdabeed", form.current, "tiNvqcE-t48hL3MQ2")
      .then(
        () => {
          setLoading(false);
          toast.success("Successfully sent email.");
          setName("");
          setEmail("");
          setMessage("");
        },
        (error) => {
          console.error("EmailJS Error: ", error);
          toast.error("Error in sending email: " + (error?.text || "Unknown error"));
        }
      );
  };



  return (
    <>
      <ToastContainer></ToastContainer>
      <form ref={form} onSubmit={submitHandler} id="contact">

        <h1>Contact Form</h1>

        <label>Name</label>
        <input type="text" name="name" value={name} onChange={(e) => setName(e.target.value)} required />

        <label>Email</label>
        <input type="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} required />

        <label>Message</label>
        <textarea name="message" value={message} onChange={(e) => setMessage(e.target.value)} required />

        <input type="submit" value="Send" />
      </form>

    </>
  );
};
